module.exports = __webpack_public_path__ + "static/media/C002.7f8d3a92.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/carousel/C002.jpg
// module id = 285
// module chunks = 0